export const WALLET_CONNECT_LOCAL_KEY = "walletconnect";
export const LOCAL_TOKEN_KEY = "ethereum_auth_token";
export const WALLET_TYPES = {
  browser: "browser",
  walletConnect: "walletConnect"
};
